module.exports = __webpack_public_path__ + "static/img/sm_bot1.51ecbb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/sm_bot1.png
// module id = l3/4
// module chunks = 1